<template>
    <div class="investors-c">
        <p class="indent">Events calendar for investors - Our financial reporting schedule, calendar for all IR events and important meeting and event dates</p>
        <div class="investors-calendar-wrapper">
          <table class="investors-calendar">
            <thead>
              <tr class="investors-calendar-row">
                <td class="investors-calendar-main-title" colspan="2">
                  <span class="alcomet investors-calendar-title-icon">t</span>
                  <span v-if="isCalendarMode">&nbsp;{{months[calendarDate.getMonth()]}} {{calendarDate.getFullYear()}} Upcoming Events</span>
                  <span v-else>&nbsp;Upcoming Events</span>
                </td>
                <td class="investors-calendar-add calendar-view">
                    <span class="toggle-mode-wrapper">
                      <span class="toggle-mode-text">Calendar view</span>
                      <span @click="calendarMode(true)" class="toggle-mode alcomet" :class="{ 'toggle-mode-active' : isCalendarMode}" title="Month">t</span>
                      <span @click="calendarMode(false)" class="toggle-mode alcomet" :class="{ 'toggle-mode-active' : !isCalendarMode}" title="Agenda">y</span>
                    </span>
                </td>
              </tr>
            </thead>
            <tbody>
              <template v-if="isCalendarMode">
                <tr :class="{ 'no-border' : isCalendarMode }">
                  <td colspan="3">
                    <datepicker
                    :inline="true"
                    :monday-first="true"
                    :full-month-name="true"
                    :wrapper-class="'custom-datepicker'"
                    :calendar-class="'custom-calendar'"
                    :highlighted="state.highlighted"
                    @changedMonth="updateCalendar($event)"
                    ></datepicker>
                  </td>
                </tr>
                <tr v-for="(event, index) in events" v-if="event.date.getMonth() === calendarDate.getMonth() && event.date.getFullYear() === calendarDate.getFullYear()" :key="index" class="investors-calendar-row">
                  <td class="investors-calendar-date">
                    <span v-if="event.date.getDate() < 10">0</span>{{event.date.getDate()}}.<span v-if="event.date.getMonth() < 9">0</span>{{event.date.getMonth() + 1}}.{{event.date.getFullYear()}}
                  </td>
                  <td class="investors-calendar-title">{{event.name}}</td>
                  <td class="alcomet investors-calendar-toggle">s</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(event, index) in events" :key="index" class="investors-calendar-row">
                  <td class="investors-calendar-date">
                    <span v-if="event.date.getDate() < 10">0</span>{{event.date.getDate()}}.<span v-if="event.date.getMonth() < 9">0</span>{{event.date.getMonth() + 1}}.{{event.date.getFullYear()}}
                  </td>
                  <td class="investors-calendar-title">{{event.name}}</td>
                  <td class="alcomet investors-calendar-toggle">s</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    Datepicker,
    appShareButton: ShareButton
  },
  data() {
    return {
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      state: {
        highlighted: {
          dates: []
        }
      },
      calendarDate: new Date(),
      isCalendarMode: false,
      events: [
        { name: "Disclosure of the individual report for the IV quarter of 2022",
          date: new Date('2023-1-30')
        },
        { name: "Disclosure of consolidated accounts for the IV quarter of 2022", date: new Date('2023-3-1') },

        { name: "Disclosure of audited financials report for 2022", date: new Date('2023-3-31') },

        { name: "Disclosure of audited concolidated financials report for 2022", date: new Date('2023-5-2') },

        { name: "Disclosure of the individual report for the I quarter of 2023", date: new Date('2023-5-2') },

        { name: "Disclosure of consolidated accounts for the I quarter of 2023", date: new Date('2023-5-30') },

        { name: "Deadline for Regular General meeting of shareholders of 2023", date: new Date('2023-6-30') },

        { name: "Disclosure of the individual report for the II quarter of 2023", date: new Date('2023-7-31') },

        { name: "Disclosure of consolidated accounts for the II quarter of 2023", date: new Date('2023-8-29') },

        { name: "Disclosure of the individual report for the III quarter of 2023", date: new Date('2022-10-30') },

        { name: "Disclosure of consolidated accounts for the III quarter of 2023", date: new Date('2023-11-29') },

        { name: "Disclosure of the individual report for the IV quarter of 2023", date: new Date('2024-1-31') },

        { name: "Disclosure of consolidated accounts for the IV quarter of 2023", date: new Date('2024-3-1') }

      ]
    };
  },
  methods: {
    updateCalendar(date) {
      this.calendarDate = date;
    },
    calendarMode(which) {
      this.isCalendarMode = which;
    }
  },
  watch: {
    isCalendarMode(to, from) {
      this.calendarDate = new Date();
    }
  },
  mounted() {
    this.events.forEach(event => {
      this.state.highlighted.dates.push(event.date);
    });
  }
};
</script>

<style scoped>
.investors-c > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.investors-calendar-wrapper {
  border-radius: 6px;
  background-color: #edf2f4;
  margin: 30px auto 0;
  padding: 20px 10%;
  width: 80%;
}
.investors-calendar {
  border-collapse: collapse;
  margin: 0 auto;
  margin-left: -20px;
  width: calc(100% + 40px);
}
.investors-calendar tr {
  border-bottom: 1px solid #becddb;
}
.investors-calendar .no-border {
  border: none;
}
.investors-calendar tr,
.investors-calendar td {
  padding-bottom: 21px;
  padding-top: 21px;
}
.investors-calendar-main-title {
  padding-left: 20px;
  width: 85%;
}
.investors-calendar-main-title > * {
  vertical-align: middle;
  font-size: 24px;
  font-weight: 500;
}
.investors-calendar-title-icon {
  color: #8eaec8;
  font-size: 28px;
  margin-right: 10px;
}
.investors-calendar-add {
  height: 100%;
  text-align: right;
  padding-right: 20px;
  width: 15%;
}
.calendar-view {
  position: relative;
}
.toggle-mode-wrapper {
  align-items: center;
  display: inline-flex;
}
.toggle-mode-text {
  color: rgba(0, 71, 133, 0.5);
  font-size: 12px;
  display: inline-flex;
  white-space: nowrap;
}
.toggle-mode {
  color: rgba(0, 71, 133, 0.5);
  cursor: pointer;
  font-size: 20px;
  margin: 4px 0 4px 10px;
}
.toggle-mode-active {
  color: #004787;
}
.investors-calendar-date {
  font-size: 14px;
  padding-left: 20px;
  padding-right: 20px;
}
.investors-calendar-title {
  font-size: 16px;
  font-weight: 500;
  width: 78%;
}
.investors-calendar-toggle {
  cursor: pointer;
  font-size: 20px;
  text-align: right;
  padding-right: 20px;
  width: 10%;
}
@media screen and (max-width: 1000px) {
  .investors-c > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .investors-calendar-wrapper {
    width: calc(100% - 60px);
  }
  .investors-calendar-main-title > *,
  .toggle-mode,
  .investors-calendar-toggle {
    font-size: 18px;
  }
  .investors-calendar-title {
    font-size: 14px;
  }
}
@media screen and (max-width: 600px) {
  .toggle-mode-text {
    display: none;
  }
  .investors-calendar-wrapper {
    padding: 20px;
  }
  .investors-calendar {
    margin: 0;
    width: 100%;
  }
  .investors-calendar-main-title,
  .investors-calendar-date {
    padding-left: 0;
  }
  .calendar-view,
  .investors-calendar-toggle {
    padding-right: 0;
  }
  .investors-calendar-main-title > *,
  .toggle-mode,
  .investors-calendar-toggle {
    font-size: 14px;
  }
  .investors-calendar-title-icon {
    margin-right: 5px;
  }
  .investors-calendar-title,
  .investors-calendar-date {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/Calendar.vue